(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'cardEditInfo',
            [
                'SECTIONS',
                CardEditInfoFactory
            ]
        );

    // Factory Method
    function CardEditInfoFactory(SECTIONS)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            scope: false,
            templateUrl: SECTIONS.PREFIX + SECTIONS.ACCOUNT.PROFILE_CARD_INFO + SECTIONS.POSTFIX
        };

    }
})();



